import {
  MissionContext,
} from "modules/pvs_activities/components/contexts/MissionTasksContext";
import React, { useContext, useEffect, useState } from "react";
import AddMissionTask from "modules/pvs_activities/components/mission/AddMissionTask";
import MissionWorkFlow from "./MissionWorkFlow";
import CardBody from "components/common/CardBody";
import MissionDocument from "modules/pvs_activities/components/document/MissionDocument";
import {
  Accordion,
  AccordionSummary,
  IconButton,
  Tab,
  Tabs,
} from "@mui/material";
import MissionTasks from "modules/pvs_activities/components/mission/MissionTasks";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Row from "components/common/Row";
import Column from "components/common/Column";
import TabPanel from "pages/frontend/components/staffComponents/TabPanel";
import Loader from "components/spinner/Loader";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import RaiseAnIssue from "modules/pvs_activities/components/mission/RaiseAnIssue";
import CustomCard from "components/common/CustomCard";
import { USER_ROLES } from "constants";

const MissionDashboard = ({ config, id }) => {
  const missionContext = useContext(MissionContext);
  const isAccordionDisabled =
    !missionContext?.missionData?.relationMissionManager;
  const [missionWorkFlow, setMissionWorkFlow] = useState(isAccordionDisabled);
  const [missionCC, setMissionCC] = useState(isAccordionDisabled);
  const [missionDocument, setMissionDocument] = useState(false);
  const [value, setValue] = useState(0);
  const authData = useSelector((s) => s.auth.data);
  const { t } = useTranslation();
  const [missionIssues, setMissionIssues] = useState(false)

  useEffect(() => {
    setMissionWorkFlow(!isAccordionDisabled);
    setMissionCC(!isAccordionDisabled);
  }, [isAccordionDisabled, missionIssues]);

  const handleAccordion2 = () => {
    if (!isAccordionDisabled) {
      setMissionCC(!missionCC);
    }
  };

  const handleAccordion3 = () => {
    if (!isAccordionDisabled) {
      setMissionWorkFlow(!missionWorkFlow);
    }
  };

  const handleAccordion4 = () => {
    if (!isAccordionDisabled) {
      setMissionDocument(!missionDocument);
    }
  };
  const handleAccordion5 = () => {
    if (!isAccordionDisabled) {
      setMissionIssues(!missionIssues);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {missionContext.missionData?.relationMissionManager ? (
        <>
          <CustomCard className="shadow-sm my-3 bg-white">
            <CardBody>
              {missionContext.isLoading ? (
                <Loader message={"Loading..."} className="text-muted ms-3" />
              ) : (
                <Row className="d-flex justify-content-center">
                  <Column
                    className="text-center d-flex justify-content-center align-items-center"
                    col={12}
                  >
                    <Tabs value={value} onChange={handleChange}>
                      <Tab
                        className="fw-bold fs-5"
                        label="Mission WorkFlow"
                        value={0}
                      />
                      {USER_ROLES.business_admin.includes(
                        parseInt(authData?.role_id)
                      ) &&
                        missionContext.showReport && (
                          <Tab
                            className="fw-bold fs-5"
                            label="Report WorkFlow"
                            value={1}
                          />
                        )}
                    </Tabs>
                  </Column>
                </Row>
              )}
            </CardBody>
          </CustomCard>

          {missionContext.isLoading ? (
            <Loader />
          ) : (
            <>
              <TabPanel value={value} index={0}>
                <div className="pb-2">
                  <Accordion
                    className="pb-2"
                    style={{ border: "1px solid lightgray" }}
                    expanded={missionWorkFlow}
                  >
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordion3}
                          aria-expanded={missionWorkFlow}
                          aria-label="toggle accordion"
                          disabled={isAccordionDisabled}
                        >
                          {missionWorkFlow ? (
                            <RemoveCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          ) : (
                            <AddCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </IconButton>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="fs-4"
                    >
                      <div className="d-flex px-1 w-100 ">
                        <div className="card-title1 lh-1">
                          {t("-1", "Mission Workflow Status")}
                        </div>
                      </div>
                    </AccordionSummary>
                    <MissionWorkFlow
                      mission_context={{
                        movements: missionContext.movements.filter(
                          (x) =>
                            x.d_form_id &&
                            x.relationForm?.mission_phase_id !== 344
                        ),
                        processes: missionContext.processes?.filter(
                          (x) =>
                            x.d_form_id &&
                            x.relationProcessForm?.mission_phase_id !== 344
                        ),
                        missionManager: missionContext.missionManager,
                      }}
                    />
                  </Accordion>
                </div>

                <div className="pb-2">
                  <Accordion
                    className="pb-2"
                    style={{ border: "1px solid lightgray" }}
                    expanded={missionCC}
                  >
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordion2}
                          aria-expanded={missionCC}
                          aria-label="toggle accordion"
                          disabled={isAccordionDisabled}
                        >
                          {missionCC ? (
                            <RemoveCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          ) : (
                            <AddCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </IconButton>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="fs-4"
                    >
                      <div className="d-flex px-1 w-100 ">
                        <div className="card-title1 lh-1">
                          {t("-1", "Mission Tasks")}
                        </div>
                      </div>
                    </AccordionSummary>
                    <MissionTasks
                      showReportBugButton={true}
                      taskTableFilterConfigurations={{
                        showCountry: false,
                        showMissionType: false,
                        showMissionPhase: true,
                        showDueDate: true,
                        showStatus: true,
                        showPersonAssigned: true,
                        is_report_shown: false,
                        value: value,
                      }}
                    />
                    {config.showAddMissionTasks && (
                      <AddMissionTask missionID={id} />
                    )}
                  </Accordion>
                </div>

                <div className="pb-2">
                  <Accordion
                    className="pb-2"
                    style={{ border: "1px solid lightgray" }}
                    expanded={missionDocument}
                  >
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordion4}
                          aria-expanded={missionDocument}
                          aria-label="toggle accordion"
                          disabled={isAccordionDisabled}
                        >
                          {missionDocument ? (
                            <RemoveCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          ) : (
                            <AddCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </IconButton>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="fs-4"
                    >
                      <div className="d-flex px-1 w-100 ">
                        <div className="card-title1 lh-1">
                          {t("-1", "Mission Documents")}
                        </div>
                      </div>
                    </AccordionSummary>
                    <MissionDocument missionID={id} userID={authData.id} />
                  </Accordion>
                </div>
              </TabPanel>

              <TabPanel value={value} index={1}>
                <div className="pb-2">
                  <Accordion
                    className="pb-2"
                    style={{ border: "1px solid lightgray" }}
                    expanded={missionWorkFlow}
                  >
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordion3}
                          aria-expanded={missionWorkFlow}
                          aria-label="toggle accordion"
                          disabled={isAccordionDisabled}
                        >
                          {missionWorkFlow ? (
                            <RemoveCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          ) : (
                            <AddCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </IconButton>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="fs-4"
                    >
                      <div className="d-flex px-1 w-100 ">
                        <div className="card-title1 lh-1">
                          {t(
                            "-1",
                            value === 0
                              ? "Mission Workflow Status"
                              : "Report Workflow Status"
                          )}
                        </div>
                      </div>
                    </AccordionSummary>
                    <MissionWorkFlow
                      mission_context={{
                        movements: missionContext.movements.filter(
                          (x) =>
                            x.d_form_id &&
                            x.relationForm?.mission_phase_id === 344
                        ),
                        processes: missionContext.processes?.filter(
                          (x) =>
                            x.d_form_id &&
                            x.relationProcessForm?.mission_phase_id == 344
                        ),
                        missionManager: missionContext.missionManager,
                      }}
                    />
                  </Accordion>
                </div>

                <div className="pb-2">
                  <Accordion
                    className="pb-2"
                    style={{ border: "1px solid lightgray" }}
                    expanded={missionCC}
                  >
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordion2}
                          aria-expanded={missionCC}
                          aria-label="toggle accordion"
                          disabled={isAccordionDisabled}
                        >
                          {missionCC ? (
                            <RemoveCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          ) : (
                            <AddCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </IconButton>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="fs-4"
                    >
                      <div className="d-flex px-1 w-100 ">
                        <div className="card-title1 lh-1">
                          {t("-1", "Mission Tasks")}
                        </div>
                      </div>
                    </AccordionSummary>
                    <MissionTasks
                      showReportBugButton={true}
                      taskTableFilterConfigurations={{
                        showCountry: false,
                        showMissionType: false,
                        showMissionPhase: true,
                        showDueDate: true,
                        showStatus: true,
                        showPersonAssigned: true,
                        is_report_shown: value === 1 ? true : false,
                        value: value,
                      }}
                    />
                    {config.showAddMissionTasks && (
                      <AddMissionTask missionID={id} />
                    )}
                  </Accordion>
                </div>

                <div className="pb-2">
                  <Accordion
                    className="pb-2"
                    style={{ border: "1px solid lightgray" }}
                    expanded={missionDocument}
                  >
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordion4}
                          aria-expanded={missionDocument}
                          aria-label="toggle accordion"
                          disabled={isAccordionDisabled}
                        >
                          {missionDocument ? (
                            <RemoveCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          ) : (
                            <AddCircleIcon
                              sx={{ color: "#FF7954" }}
                              style={{ fontSize: "25px" }}
                            />
                          )}
                        </IconButton>
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="fs-4"
                    >
                      <div className="d-flex px-1 w-100 ">
                        <div className="card-title1 lh-1">
                          {t("-1", "Mission Documents")}
                        </div>
                      </div>
                    </AccordionSummary>
                    <MissionDocument missionID={id} userID={authData.id} />
                  </Accordion>
                </div>
              </TabPanel>
              {USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) && (
                <>
                  <div className="pb-2">
                    <Accordion
                      className="pb-2"
                      style={{ border: "1px solid lightgray" }}
                      expanded={missionIssues}
                    >
                      <AccordionSummary
                        expandIcon={
                          <IconButton onClick={handleAccordion5} aria-expanded={missionIssues} aria-label="toggle accordion" disabled={isAccordionDisabled} >
                            {missionIssues ? (
                              <RemoveCircleIcon sx={{ color: "#FF7954" }} style={{ fontSize: "25px" }} />
                            ) : (
                              <AddCircleIcon sx={{ color: "#FF7954" }} style={{ fontSize: "25px" }} />
                            )}
                          </IconButton>
                        }
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className="fs-4"
                      >
                        <div className="d-flex px-1 w-100 ">
                          <div className="card-title1 lh-1">{t("-1", "Issues Reported By Users")}</div>
                        </div>
                      </AccordionSummary>
                      <RaiseAnIssue missionId={missionContext?.missionData?.id} />
                    </Accordion>
                  </div>

                </>
              )}
            </>
          )}
        </>
      ) : null}
    </>
  );
};

export default MissionDashboard;
